<template>
  <div>
    <nav-header
      ref="navHeader"
      v-bind:showSearch="p_showSearch"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"
      v-bind:loginModalFlag="p_loginModalFlag"></nav-header>
    <nav-bread>
      <span slot="address">选择地址</span>
    </nav-bread>
    <div class="checkout-page">
      <svg style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1"
           xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <symbol id="icon-add" viewBox="0 0 31 32">
            <title>add</title>
            <path class="path1"
                  d="M30.745 15.152h-14.382v-14.596c0-0.308-0.243-0.557-0.543-0.557s-0.543 0.249-0.543 0.557v14.596h-14.665c-0.3 0-0.543 0.249-0.543 0.557s0.243 0.557 0.543 0.557h14.665v15.177c0 0.307 0.243 0.557 0.543 0.557s0.543-0.249 0.543-0.557v-15.177h14.382c0.3 0 0.543-0.249 0.543-0.557s-0.243-0.557-0.543-0.557z"></path>
          </symbol>
          <symbol id="icon-ok" viewBox="0 0 32 32">
            <title>ok</title>
            <path class="path1"
                  d="M14.084 20.656l-7.845-9.282c-1.288-1.482-3.534-1.639-5.016-0.351s-1.639 3.534-0.351 5.016l10.697 12.306c1.451 1.669 4.057 1.623 5.448-0.096l18.168-22.456c1.235-1.527 0.999-3.765-0.528-5.001s-3.765-0.999-5.001 0.528l-15.573 19.337z"></path>
          </symbol>
          <symbol id="icon-edit" viewBox="0 0 32 32">
            <title>edit</title>
            <path class="path1"
                  d="M28.287 8.51l-4.805-4.806 0.831-0.831c0.472-0.472 1.086-0.777 1.564-0.777 0.248 0 0.452 0.082 0.622 0.253l3.143 3.144c0.539 0.54 0.133 1.529-0.524 2.186l-0.831 0.831zM26.805 9.992l-1.138 1.138-4.805-4.806 1.138-1.138 4.805 4.806zM24.186 12.612l-14.758 14.762-4.805-4.806 14.758-14.762 4.805 4.806zM7.379 28.288l-4.892 1.224 1.223-4.894 3.669 3.67zM31.123 4.011l-3.143-3.144c-0.567-0.567-1.294-0.867-2.103-0.867-1.036 0-2.174 0.52-3.045 1.391l-20.429 20.436c-0.135 0.134-0.23 0.302-0.276 0.487l-2.095 8.385c-0.089 0.355 0.017 0.736 0.276 0.995 0.198 0.198 0.461 0.307 0.741 0.307 0.085 0 0.171-0.010 0.254-0.031l8.381-2.096c0.185-0.047 0.354-0.142 0.487-0.276l20.43-20.436c1.409-1.41 2.042-3.632 0.524-5.15v0z"></path>
          </symbol>
          <symbol id="icon-del" viewBox="0 0 32 32">
            <title>delete</title>
            <path class="path1"
                  d="M11.355 4.129v-2.065h9.29v2.065h-9.29zM6.194 29.935v-23.742h19.613v23.742h-19.613zM30.968 4.129h-8.258v-3.097c0-0.569-0.463-1.032-1.032-1.032h-11.355c-0.569 0-1.032 0.463-1.032 1.032v3.097h-8.258c-0.569 0-1.032 0.463-1.032 1.032s0.463 1.032 1.032 1.032h3.097v24.774c0 0.569 0.463 1.032 1.032 1.032h21.677c0.569 0 1.032-0.463 1.032-1.032v-24.774h3.097c0.569 0 1.032-0.463 1.032-1.032s-0.463-1.032-1.032-1.032v0z"></path>
            <path class="path2"
                  d="M10.323 9.806c-0.569 0-1.032 0.463-1.032 1.032v14.452c0 0.569 0.463 1.032 1.032 1.032s1.032-0.463 1.032-1.032v-14.452c0-0.569-0.463-1.032-1.032-1.032z"></path>
            <path class="path3"
                  d="M16 9.806c-0.569 0-1.032 0.463-1.032 1.032v14.452c0 0.569 0.463 1.032 1.032 1.032s1.032-0.463 1.032-1.032v-14.452c0-0.569-0.463-1.032-1.032-1.032z"></path>
            <path class="path4"
                  d="M21.677 9.806c-0.569 0-1.032 0.463-1.032 1.032v14.452c0 0.569 0.463 1.032 1.032 1.032s1.032-0.463 1.032-1.032v-14.452c0-0.569-0.463-1.032-1.032-1.032z"></path>
          </symbol>
          <symbol id="icon-clock" viewBox="0 0 32 32">
            <title>clock</title>
            <path class="path1"
                  d="M29.333 16c0-7.364-5.97-13.333-13.333-13.333s-13.333 5.97-13.333 13.333c0 7.364 5.97 13.333 13.333 13.333s13.333-5.97 13.333-13.333v0 0 0 0 0 0zM0 16c0-8.837 7.163-16 16-16s16 7.163 16 16c0 8.837-7.163 16-16 16s-16-7.163-16-16zM14.667 14.667v1.333h2.667v-10.667h-2.667v9.333zM24 18.667h1.333v-2.667h-10.667v2.667h9.333z"></path>
          </symbol>
          <symbol id="icon-question" viewBox="0 0 32 32">
            <title>question</title>
            <path class="path1"
                  d="M16 2.56c7.411 0 13.44 6.029 13.44 13.44s-6.029 13.44-13.44 13.44c-7.411 0-13.44-6.029-13.44-13.44s6.029-13.44 13.44-13.44zM16 0c-8.822 0-16 7.178-16 16s7.178 16 16 16c8.822 0 16-7.178 16-16s-7.178-16-16-16z"></path>
            <path class="path2"
                  d="M16 22.080c-1.059 0-1.92 0.861-1.92 1.92s0.861 1.92 1.92 1.92c1.059 0 1.92-0.861 1.92-1.92s-0.861-1.92-1.92-1.92z"></path>
            <path class="path3"
                  d="M12.16 12.48c0.706 0 1.28-0.574 1.28-1.28 0-1.412 1.148-2.56 2.56-2.56s2.56 1.148 2.56 2.56c0 1.412-1.148 2.56-2.56 2.56-0.706 0-1.28 0.574-1.28 1.28v3.84c0 0.706 0.574 1.28 1.28 1.28s1.28-0.574 1.28-1.28v-2.723c2.224-0.575 3.84-2.616 3.84-4.957 0-2.823-2.297-5.12-5.12-5.12s-5.12 2.297-5.12 5.12c0 0.706 0.574 1.28 1.28 1.28z"></path>
          </symbol>
        </defs>
      </svg>
      <div class="container">
        <div class="checkout-addr">
          <!--<div class="page-title-normal">-->
          <!--<h2 class="page-title-h2"><span>check out</span></h2>-->
          <!--</div>-->
          <!-- process step -->
          <div class="check-step">
            <ul>
              <li class="cur"><span>选择地址</span></li>
              <li><span>确认订单</span></li>
              <li><span>下单成功</span></li>
            </ul>
          </div>

          <!-- address list -->
          <div class="page-title-normal checkout-title">
            <h2  v-if="this.pkey == true && this.type == 3"><span>采样地址</span></h2>
            <h2  v-else><span>配送地址</span></h2>
          </div>
          <div class="addr-list-wrap">
            <div class="addr-list">
              <ul>
                <!-- 推广人地址 -->
                <li v-if="this.pkey == true && this.type == 3" v-model="infoList" v-bind:class="{'check':infoList}"
                  @click="check" >
                  <dl>
                    <dt>{{infoList.userName}}</dt>
                    <dd class="address">{{infoList.provinceName? infoList.provinceName: ''}}{{infoList.cityName ? infoList.cityName: ''}}{{infoList.countyName ? infoList.countyName: ''}}{{infoList.detailInfo}}</dd>
                    <!-- <dd class="tel">{{infoList.telNumber}}</dd> -->
                  </dl>
                   <div class="addr-opration addr-del" style="right:60px;">
                    <a href="javascript:;" class="addr-del-btn" @click="editAdd()">
                      <i class="el-icon-edit"></i>
                    </a>
                  </div>
                </li>

                <li v-else v-for="(item,index) in addressList" :key="index" v-bind:class="{'check':checkedIndex == index}"
                    @click="checkAddress(index,item.id)">
                  <dl>
                    <dt>{{item.userName}}</dt>
                    <dd class="address">{{item.provinceName+item.cityName+item.countyName+item.detailInfo}}</dd>
                    <dd class="tel">{{item.telNumber}}</dd>
                  </dl>
                  <div class="addr-opration addr-del">
                    <a href="javascript:;" class="addr-del-btn" @click="delAddress(item.id)">
                      <i class="el-icon-delete"></i>
                    </a>
                  </div>
                  <div class="addr-opration addr-del" style="right:60px;">
                    <a href="javascript:;" class="addr-del-btn" @click="editAddress(item.id)">
                      <i class="el-icon-edit"></i>
                    </a>
                  </div>
                  <div class="addr-opration addr-default" v-if="item.default == 1">默认地址</div>
                </li>

                <li v-if="this.pkey == false" class="addr-new"
                    v-loading="loading">
                  <div class="add-new-inner" @click="addAddress">
                    <i class="icon-add">
                      <svg class="icon icon-add">
                        <use xlink:href="#icon-add"></use>
                      </svg>
                    </i>
                    <p>添加新地址</p>
                  </div>
                </li>
              </ul>
            </div>

            <!--<div class="shipping-addr-more">-->
            <!--<a class="addr-more-btn up-down-btn" href="javascript:;" @click="expend" v-bind:class="{'open':limit>3}" v-if="limit > 3">-->
            <!--更多{{limit}}-->
            <!--<i class="i-up-down">-->
            <!--<i class="i-up-down-l"></i>-->
            <!--<i class="i-up-down-r"></i>-->
            <!--</i>-->
            <!--</a>-->
            <!--</div>-->
          </div>

          <!-- shipping method-->
          <!--<div class="page-title-normal checkout-title">-->
          <!--<h2><span>Shipping method</span></h2>-->
          <!--</div>-->
          <!--<div class="shipping-method-wrap">-->
          <!--<div class="shipping-method">-->
          <!--<ul>-->
          <!--<li class="check">-->
          <!--<div class="name">Standard shipping</div>-->
          <!--<div class="price">Free</div>-->
          <!--<div class="shipping-tips">-->
          <!--<p>Once shipped，Order should arrive in the destination in 1-7 business days</p>-->
          <!--</div>-->
          <!--</li>-->
          <!--</ul>-->
          <!--</div>-->
          <!--</div>-->
          <div class="invoice">
            <el-form ref="dataForm" :inline="true" :model="invoiceObj" :rules="dataRule" label-width="80px" id="dataForm">
              <el-row class="invoice_base">
                <el-col :span="24">
                  <el-form-item label="获知渠道:" label-width="100px">
                    <el-select v-model="invoiceObj.access" clearable>
                      <el-option
                        v-for="item in accessList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="invoice_base">
                <el-col :span="24">
                  <el-form-item label="是否开具发票:" label-width="100px" prop="invoiceFlag">
                    <el-select v-model="invoiceObj.invoiceFlag" @change="e => changeRule('invoiceFlag', e)">
                      <el-option label="暂不开票" value="0"></el-option>
                      <el-option label="开具发票" value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="invoiceObj.invoiceFlag != 0">
                <el-row class="invoice_info">
                  <el-col :span="24">
                    <el-form-item label="抬头类型" prop="userType"
                                  :rules="[
                                    { required: true, message: '抬头类型不能为空' }
                                  ]">
                      <el-select v-model="invoiceObj.userType" @change="e => changeRule('userType', e)">
                        <el-option label="个人" value="0"></el-option>
                        <el-option label="企业" value="1"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="发票类型" prop="invoiceType" v-if="invoiceObj.userType == '1'"
                                  :rules="[
                                    { required: true, message: '发票类型不能为空' }
                                  ]">
                      <el-select v-model="invoiceObj.invoiceType" @change="e => changeRule('invoiceType', e)">
                        <el-option label="普通发票" value="0"></el-option>
                        <!--<el-option label="专用发票" value="1"></el-option>-->
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="发票抬头" prop="invoice"
                                  :rules="[
                                    { required: true, message: '发票抬头不能为空' },
                                    { max: 30, message: '长度不能超过30个字符' }
                                  ]">
                      <el-autocomplete
                        v-if="invoiceObj.userType == '1'"
                        v-model="invoiceObj.invoice"
                        :fetch-suggestions="querySearchInvoice"
                        @select="handleSelectInvoice">
                        <template slot-scope="{ item }">
                          <div class="autocompleteInvoice">
                            <div class="name">
                              <p>{{ item.value }}</p>
                              <p class="tin">{{ item.tin }}</p>
                            </div>
                            <div class="reported">
                              <a v-if="item.status === -1" style="color: #8b8b8b;">已上报</a>
                              <a v-else @click="reportedHandle(item, item.id)">错误上报</a>
                            </div>
                          </div>
                        </template>
                      </el-autocomplete>
                      <el-input v-else v-model="invoiceObj.invoice"></el-input>
                    </el-form-item>
                    <!--企业类型-->
                    <template v-if="invoiceObj.userType == '1'">
                      <el-form-item label="税号" prop="tin"
                                    :rules="[
                                      { required: true, message: '税号不能为空' },
                                      { max: 20, message: '长度不能超过20个字符' }
                                    ]">
                        <el-input v-model="invoiceObj.tin"></el-input>
                      </el-form-item>
                      <!--专用类型-->
                      <template v-if="invoiceObj.invoiceType == '1'">
                        <el-form-item label="开户银行" prop="bankDeposit"
                                      :rules="[
                                        { required: true, message: '开户银行不能为空' },
                                        { max: 50, message: '长度不能超过50个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.bankDeposit"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账号" prop="bankAccount"
                                      :rules="[
                                        { required: true, message: '银行账号不能为空' },
                                        { max: 20, message: '长度不能超过20个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.bankAccount"></el-input>
                        </el-form-item>
                        <el-form-item label="企业地址" prop="address"
                                      :rules="[
                                        { required: true, message: '企业地址不能为空' },
                                        { max: 100, message: '长度不能超过100个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.address"></el-input>
                        </el-form-item>
                        <el-form-item label="企业电话" prop="mobile"
                                      :rules="[
                                        { required: true, message: '企业电话不能为空' },
                                        { max: 20, message: '长度不能超过20个字符' }
                                      ]">
                          <el-input v-model="invoiceObj.mobile"></el-input>
                        </el-form-item>
                      </template>
                    </template>
                    <el-form-item label="寄送类型" prop="sendType"
                                  :rules="[
                                    { required: true, message: '寄送类型不能为空' }
                                  ]">
                      <el-select v-model="invoiceObj.sendType" @change="e => changeRule('', e)">
                        <!--<el-option label="货票同行" value="0"></el-option>-->
                        <!--<el-option label="货票分离" value="1"></el-option>-->
                        <el-option label="电子发票" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="接收方式" prop="invoiceReceiveValue"
                                  v-if="invoiceObj.sendType === '2'"
                                  :rules="invoiceObj.invoiceReceiveType == 0 ? [
                                    { required: true, message: '接收方式不能为空' },
                                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                                  ] : [
                                    { required: true, message: '接收方式不能为空' },
                                    { pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] }
                                  ]">
                      <el-input placeholder="请输入" v-model="invoiceObj.invoiceReceiveValue">
                        <el-select v-model="invoiceObj.invoiceReceiveType" slot="prepend" placeholder="请选择" style="width:90px">
                          <!--<el-option label="邮箱" :value="0"></el-option>-->
                          <el-option label="手机号" :value="1"></el-option>
                        </el-select>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <el-row class="invoice_base">
                <!--代理商-->
                <el-col :span="24" v-if="user.isChannel == 1 && user.channel.parentId == 0">
                  <el-form-item label="订单客户:" label-width="100px" prop="dealerName"
                                :rules="[
                                  { max: 50, message: '长度不能超过50个字符' }
                                ]">
                    <el-autocomplete
                      v-model="invoiceObj.dealerName"
                      :fetch-suggestions="querySearch"
                      placeholder="请填写"
                      @select="handleSelectCustomer"
                    ></el-autocomplete>
                  </el-form-item>
                </el-col>
                <!--经销商-->
                <el-col :span="24" v-if="user.isChannel == 1 && user.channel.parentId != 0">
                  <el-form-item label="订单客户:" label-width="100px" prop="customerName"
                                :rules="[
                                  { max: 50, message: '长度不能超过50个字符' }
                                ]">
                    <el-input v-model="invoiceObj.customerName" placeholder="请填写"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注:" label-width="100px" prop="remark"
                                :rules="[{ max: 100, message: '长度不能超过100个字符' }]">
                    <el-input type="textarea" v-model="invoiceObj.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div class="next-btn-wrap" v-show="!loading">
            <!--<router-link class = "btn btn&#45;&#45;m btn&#45;&#45;red" v-bind:to="{path:'orderConfirm',query:{'addressId':selectedAddrId}}">下一步</router-link>-->
            <a herf="javascript:;" class="btn btn--m btn--red" @click="toOrderConfirm">下一步</a>
          </div>

        </div>
      </div>
    </div>
    <!--<nav-footer></nav-footer>-->


    <address-modal v-bind:c_mdshow='p_mdshow' v-on:c_close='p_close' v-on:c_getList="getAddressList" ref="addressAdd">
      <span slot="msg">
        新增地址
      </span>
      <!--<div slot='btnGroup'>-->
      <!--<a href="javascript:;" class = 'btn btn&#45;&#45;m' @click='p_mdshow=false'>关闭</a>-->
      <!--</div>-->
    </address-modal>
    <address-edit-modal
      ref="addressEdit"
      v-bind:c_mdshow_edit='p_mdshow_edit'
      v-bind:c_addressDetailObj='p_addressDetailObj'
      v-on:c_getAddressDetail="p_getAddressDetail"
      v-on:c_close_edit='p_close_edit'
      v-on:c_getList_edit="getAddressList"
      v-bind:c_editId="p_editId"
      v-bind:c_default="p_default">
      <span slot="msg">
        编辑地址
      </span>
      <!--<div slot='btnGroup'>-->
      <!--<a href="javascript:;" class = 'btn btn&#45;&#45;m' @click='p_mdshow=false'>关闭</a>-->
      <!--</div>-->
    </address-edit-modal>
    <add-edit
      ref="addEdit"
      v-bind:c_edit='edit'
      v-bind:c_Obj='infoObj'
      v-on:c_close='close_edit'
      v-on:c_get_edit="getpromoterInfo"
      >
      <span slot="msg">
        编辑地址
      </span>
    </add-edit>
  </div>
</template>
<style scoped>
</style>
<script>
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread'
  import NavFooter from '@/components/Footer'
  import Modal from '@/components/Modal'
  import AddressModal from '@/components/AddressModal'
  import AddressEditModal from '@/components/AddressEditModal'
  import AddEdit from '@/components/AddEdit'
  import '@/assets/css/base.css'
  import '@/assets/css/checkout.css'
  import '@/assets/css/index.css'
  import {getCookie,delCookie} from "../../util/util";
  // import '@/assets/css/product.css'

  import axios from 'axios'

  export default {
   name: "Address",
    data() {
      return {
        infoList:[],
        addressList: [],
        checkedIndex: 0,
        // limit:3,
        p_mdshow: false,
        p_mdshow_edit: false,
        p_mdshow2: false,
        edit: false,
        addressId: '',
        selectedAddrId: '',
        p_editId: "",
        p_addressDetailObj: {},
        infoObj:{},
        loading: true,
        p_default: false,
        p_showSearch: true,
        p_loginModalFlag: false,
        invoiceObj: {
          access: '',
          invoiceFlag: '0',
          userType: '0',
          invoiceType: '0',
          invoice: '',
          tin: '',
          bankDeposit: '',
          bankAccount: '',
          address: '',
          mobile: '',
          sendType: '2',
          invoiceReceiveType: 1,
          invoiceReceiveValue: '',
          remark: '', // 订单备注
          dealerId: '', // 经销商id
          dealerCode: '', // 经销商code
          dealerName: '', // 经销商名称
          customerName: '' // 客户名称
        },
        dataRule: {},
        pkey:false,
        type:this.$route.query.type,
        clientList: [], // 代理商绑定的经销商
        accessList: [
          {
            value: 1,
            label: '百度搜索'
          },
          {
            value: 2,
            label: '短视频（抖音/小红书等）'
          },
          {
            value: 3,
            label: '自媒体（微博/知乎/搜狐/今日头条等）'
          },
          {
            value: 4,
            label: '亲朋推荐'
          },
          {
            value: 5,
            label: '媒体广告'
          },
          {
            value: 6,
            label: '代理/医院'
          },
          {
            value: 9,
            label: '其他'
          }
        ]
      }
    },
    components: {
      NavHeader,
      NavBread,
      NavFooter,
      Modal,
      AddressModal,
      AddressEditModal,
      AddEdit

    },
    watch: {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      c_Obj() {
        return this.$store.state.c_Obj;
      },
      checkedGoodsList(){
        return this.$store.state.checkedGoodsList;
      },
    },
    mounted() {
      if (getCookie("_token")) {
        this.getAddressList()
        this.getpromoterInfo()
        this.getClientList()
        // 判断商品类型是否都是服务类(服务类展示医生地址)
        let types = [];
        for (var i = 0; i < this.checkedGoodsList.length; i++) {
          let list = this.checkedGoodsList[i].type
          types.push(list)
        }
        //  console.log(types)
        if (types.every(function(value, index, types){
           return value === 3
         })) {
           this.type = 3
         }else {
           this.type = 0
         }
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    },
    methods: {
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },
      checkAddress(index, addressId) {
        // console.log(addressId)
        this.checkedIndex = index;
        this.selectedAddrId = addressId;
        this.p_getAddressDetail(addressId);
      },
      check() {
        this.checkedIndex = null;
        // this.getpromoterInfo()
        this.p_addressDetailObj = null
      },
      //获取地址列表
      getAddressList() {
        axios.defaults.baseURL = process.env.API_ROOT
        axios.get("/jys/address/user", {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          console.log(response)
          this.addressList = response.data.list
          // this.limit = this.addressList.length
          for (var i = 0; i < this.addressList.length; i++) {
            if (this.addressList[i].default == 1) {
              this.checkedIndex = i
            }
          }

          if (this.addressList.length) {
            this.p_getAddressDetail(this.addressList[this.checkedIndex].id)
          }
          this.loading = false
        })
      },

      //获取该代理商绑定的经销商
      getClientList() {
        axios.get("/jys/client").then((res) => {
          if (res.data.code === 0) {
            this.clientList = JSON.parse(JSON.stringify(res.data.client).replace(/channelName/g,"value"))
          }
        })
      },
      querySearch(queryString, cb) {
        let clientList = this.clientList;
        let results = queryString ? clientList.filter(this.createFilter(queryString)) : clientList;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (client) => {
          return (client.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelectCustomer(item) {
        this.invoiceObj.dealerId = item.id
        this.invoiceObj.dealerCode = item.channelCode
        this.invoiceObj.dealerName = item.value
      },

      //获取发票
      querySearchInvoice(queryString, cb) {
        if (queryString) {
          axios.get("/jys/invoice/store/list", {
            params: {
              limit: 10,
              page: 1,
              invoice: queryString
            }
          }).then((res) => {
            if (res.data.code === 0) {
              cb(JSON.parse(JSON.stringify(res.data.invoiceStoreList).replace(/invoice/g,"value")))
            }
          })
        } else {
          cb([])
        }
      },
      handleSelectInvoice(item) {
        this.invoiceObj.tin = item.tin
      },
      reportedHandle(item,id) {
        axios.put('/jys/invoice/store/reported/' + id, {
        }).then((response) => {
          if (response.data.code === 0) {
            this.$message({
              message: '上报成功',
              type: 'success'
            })
            item.status = -1
          }
        })
      },

      // 新增 / 修改
      addAddress(id) {
        this.p_mdshow = true;
        this.$refs.addressAdd.getCityData()
      },
      editAdd() {
        this.edit = true
        this.getpromoterInfo('edit')
        this.infoObj = this.infoList
      },

      editAddress(id) {
        // console.log(id)
        this.p_editId = id
        this.p_mdshow_edit = true;
        this.p_getAddressDetail(id,'edit');
      },

      // 获取地址信息
      p_getAddressDetail(id, flag) {
        axios.get("/jys/address/user", {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          if (response.data.code == 0) {
            let addressList = response.data.list
            for (var i = 0; i < addressList.length; i++) {
              if (id == addressList[i].id) {
                this.p_addressDetailObj = addressList[i]
                this.p_default = addressList[i].default == 1 ? true : false
                // console.log(this.p_addressDetailObj)
                this.$store.commit("updateAddressDetail", this.p_addressDetailObj);
                if(flag === 'edit'){
                  this.$refs.addressEdit.init(this.p_addressDetailObj)
                }
              }
            }
          }
        })
      },
       // 获取推广人地址信息
      getpromoterInfo(flag){
         axios.get("jys/promotion/promoterInfo",{
           headers: {
            "Content-Type": "application/json",
            'pcKey': getCookie("pc")
          }
         })
         .then((res) => {
          console.log('res', res)
          if(res.data.promoter !== null && this.type == 3) {
            this.pkey = true
            for(let key in res.data.promoter){
              if(!res.data.promoter[key]){
                res.data.promoter[key] = ''
              }
            }
            this.infoList = res.data.promoter
            console.log('this.infoList', this.infoList)
            this.infoObj = this.infoList
            if(flag === 'edit'){
              this.$refs.addEdit.init(this.infoObj)
            }
            this.loading = false
          }
          else if(res.data.promoter == null && this.type !==3){
            this.pkey = false
          }
        })
      },

      //展开地址列表
      // expend(){
      //   if(this.limit == 3){
      //     this.limit = this.addressList.length;
      //   }else{
      //     this.limit = 3;
      //   }
      // },

      p_close() {
        this.p_mdshow = false;
        this.p_mdshow2 = false;
      },
      p_close_edit() {
        this.p_mdshow_edit = false;
      },
      close_edit() {
        this.edit = false
      },
      delAddress(addressId) {

        if (this.addressList.length > 1) {
          // this.p_mdshow = true;
          this.addressId = addressId;

          this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
            this.delAddressConfirm(addressId)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

        } else {
          //如果只剩一条数据,提示不能删除
          this.p_mdshow2 = true;
          this.$alert('当前只有一条地址信息,无法删除', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              // this.$message({
              //   type: 'info',
              //   message: `action: ${ action }`
              // });
            }
          });
        }

      },

      delAddressConfirm(id) {
        axios.delete("/jys/address/" + id, {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          let res = response.data;
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getAddressList();
          }
        })
      },

      toOrderConfirm() {
        this.$refs['dataForm'].validate((valid) => {
          console.log(this.$route.query)
          if (valid) {
            if (this.infoList.length === 0 && this.addressList.length === 0) {
              this.$message({
                showClose: true,
                message: "请添加地址信息哦",
                type: 'error'
              });
            } else if (this.pkey == true) {
              let { checkedList, groupInfo, totalMoney, fromCart, checkedSpecId } = this.$route.query
              let addressObj = JSON.stringify(this.infoObj)
              let invoiceObj = JSON.stringify(this.invoiceObj)

              this.$router.push({
                path: "orderConfirm"
              })
              localStorage.setItem('orderConfirmParams', JSON.stringify({
                'checkedList': checkedList,
                'addressObj': addressObj,
                'totalMoney': totalMoney,
                'fromCart': fromCart,
                'checkedSpecId': checkedSpecId,
                'invoiceObj': invoiceObj, //发票信息
                'groupInfo': groupInfo
              }))
            } else if (this.pkey == false) {
              let { checkedList, groupInfo, totalMoney, fromCart, checkedSpecId } = this.$route.query
              let addressObj = JSON.stringify(this.p_addressDetailObj)
              let invoiceObj = JSON.stringify(this.invoiceObj)

              this.$router.push({
                path: "orderConfirm"
              })
              localStorage.setItem('orderConfirmParams', JSON.stringify({
                'checkedList': checkedList,
                'addressObj': addressObj,
                'totalMoney': totalMoney,
                'fromCart': fromCart,
                'checkedSpecId': checkedSpecId,
                'invoiceObj': invoiceObj, //发票信息
                ...groupInfo ? { 'groupInfo': groupInfo } : {}
              }))
            }
          }
        })
      },

      // 校验规则
      changeRule (key, e) {
        // 设置值
        if (key) {
          if (key === 'invoiceFlag') {
            this.invoiceObj.userType = '0'
            this.invoiceObj.invoiceType = '0'
          } else if (key === 'userType') {
            this.invoiceObj.invoiceType = '0'
          }
          this.invoiceObj.invoice = ''
          this.invoiceObj.tin = ''
          this.invoiceObj.bankDeposit = ''
          this.invoiceObj.bankAccount = ''
          this.invoiceObj.address = ''
          this.invoiceObj.mobile = ''
          this.invoiceObj.sendType = '2'
          this.invoiceObj.invoiceReceiveType = 1
          this.invoiceObj.invoiceReceiveValue = ''
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs['dataForm'].clearValidate()
          }, 1)
        })
      }
    }
  }
</script>
<style scoped>
  .el-button--primary:focus, .el-button--primary:hover {
    background: #00C5B0;
    border-color: #00C5B0;
    color: #ffffff;
  }

  .el-icon-edit {
    width: 20px;
    height: 20px;
  }

  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-textarea__inner:focus{
    border-color: #ccc;
  }
  .container {
    width: 70%;
  }
  /deep/ .el-input-group__prepend{
    background-color: #ffffff;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .container {
      margin-top: 20px;width: 100%;
    }
    .addr-list li dt {
      line-height: 1.6em;
      height: 1.6em;
      padding: 0;
    }
      /deep/ .navbar{
          display: none;
      }
    /deep/ .md-content {
      width: 97%;
    }

    /deep/ .md-modal {
      /* margin-top: -320px; */
      position: absolute;
      top: -22px;
    }

    /* /deep/ .editmodal {
      margin-top: -94px;
    } */

    .addr-list-wrap {
      border-bottom: 1px solid #dddddd;
    }

    #dataForm {
      margin-top: 30px;
    }
    .checkout-page {
      width: 95%;
      margin: 0 auto;
    }

    /*发票*/
    .invoice_base >>> .el-form-item{
      width: 100% !important;
    }
    .invoice_info >>> .el-form-item{
      width: 100% !important;
    }

    .next-btn-wrap {
      text-align: center;
    }
  }

  #dataForm >>> .el-input__inner{
    padding-left: 15px;
  }

  /*发票*/
  .invoice{
    margin-top: 20px;
    padding-top: 30px;
    border-top: 1px solid #ddd;
  }
  /deep/  .el-form-item__label{
    text-align: left;
  }
  .invoice_base{
    margin-bottom: 0;
  }
  .invoice_base >>> .el-form-item{
    width: 50%;
  }
  .invoice_base >>> .el-form-item__content{
    width: calc(100% - 100px);
  }
  .invoice_info{
    margin-bottom: 18px;
    padding: 20px;
    background-color: #dee0e4;
  }
  .invoice_info >>> .el-form-item{
    width: 30%;
  }
  .invoice_info >>> .el-form-item__content{
    width: calc(100% - 80px);
  }
  #dataForm >>> .el-select{
    width: 100%;
  }
  /deep/ .el-autocomplete {
    width: 100%;
  }
  .autocompleteInvoice {
    margin: 5px 0;
  }
  .autocompleteInvoice .name {
    display: inline-block;
    width: calc(100% - 60px);
    vertical-align: middle;
    line-height: 20px;
  }
  .autocompleteInvoice .name p:first-child {
    white-space: pre-line;
  }
  .autocompleteInvoice .tin {
    font-size: 10px;
    color: #8b8b8b;
  }
  .autocompleteInvoice .reported {
    display: inline-block;
    width: 60px;
    vertical-align: middle;
    font-size: 11px;
    color: #999999;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/Address.vue